/* Brand pages behavior: Our Story scroll hero, belief word reveals, chapter crossfade, founder
   reveal + parallax, press filters, contact-form validation, rewards points calculator.
   Vanilla JS, no dependencies. Ported from the design's DCLogic components. */
(function () {
  'use strict';
  if (window.__yuBrand) return; window.__yuBrand = true;
  var D = document, H = D.documentElement;
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var rm = function () { return mq.matches || H.classList.contains('yu-motion'); };
  var $$ = function (sel, root) { return [].slice.call((root || D).querySelectorAll(sel)); };
  var cl = function (v) { return Math.max(0, Math.min(1, v)); };
  var ez = function (t) { return t * t * (3 - 2 * t); };
  var hh = 0;

  function headerH() {
    var h = D.querySelector('.site-header-wrap'); if (!h) return 0;
    var pos = getComputedStyle(h).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 0;
    return Math.max(0, Math.round(h.getBoundingClientRect().height));
  }
  function measure() { hh = headerH(); H.style.setProperty('--brand-hh', hh + 'px'); }

  /* ---------- word splitting for belief statements ---------- */
  function splitWords(el) {
    if (el._split) return; el._split = true;
    var walk = function (node) {
      [].slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/), frag = D.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(D.createTextNode(p)); return; }
            var s = D.createElement('span'); s.className = 'brand-belief__w'; s.setAttribute('data-step', ''); s.textContent = p; frag.appendChild(s);
          });
          node.replaceChild(frag, n);
        } else if (n.nodeType === 1) walk(n);
      });
    };
    walk(el);
  }

  /* ---------- scroll-driven pieces ---------- */
  var heroes = [], beliefs = [], chapters = [], parallax = [];

  function tickHero(xh) {
    var stk = xh.querySelector('[data-xh-stick]'), head = xh.querySelector('[data-xh-head]'), fr = xh.querySelector('[data-xh-frame]'),
      sh = xh.querySelector('[data-xh-shade]'), eb = xh.querySelector('[data-xh-word]'), ws = xh.querySelectorAll('[data-xh-w]');
    if (!stk || !head || !fr) return;
    var H0 = stk.offsetHeight, W = stk.offsetWidth;
    xh.style.height = (H0 + innerHeight * 2.4) + 'px';
    var r = xh.getBoundingClientRect();
    var p = cl((hh - r.top) / Math.max(1, r.height - H0));
    if (rm()) p = p < 0.3 ? 0 : 1;
    var seg = function (a, b) { return ez(cl((p - a) / (b - a))); };
    var x = seg(0, 0.38), k = 1 - x;
    var top0 = Math.min(H0 * 0.8, head.offsetHeight + Math.max(24, H0 * 0.05)), side0 = Math.max(20, (W - 1280) / 2, W * 0.04);
    fr.style.clipPath = 'inset(' + (top0 * k).toFixed(1) + 'px ' + (side0 * k).toFixed(1) + 'px 0px ' + (side0 * k).toFixed(1) + 'px)';
    head.style.opacity = (1 - seg(0, 0.22)).toFixed(3);
    head.style.transform = 'translate3d(0,' + (-seg(0, 0.38) * 60).toFixed(1) + 'px,0)';
    if (sh) sh.style.opacity = (seg(0.3, 0.5) * 0.5).toFixed(3);
    if (eb) { var eo = seg(0.38, 0.5); eb.style.opacity = eo.toFixed(3); eb.style.transform = 'translate3d(0,' + ((1 - eo) * 14).toFixed(1) + 'px,0)'; }
    var wp = cl((p - 0.5) / 0.3), n = ws.length;
    [].forEach.call(ws, function (w, i) {
      var t = ez(cl(wp * (n + 1) - i));
      w.style.opacity = (p < 0.36 ? 0 : t).toFixed(3);
      w.style.transform = 'translate3d(0,' + ((1 - t) * 16).toFixed(1) + 'px,0)';
      w.style.transition = 'opacity 500ms cubic-bezier(0.22, 1, 0.36, 1)';
    });
  }

  function tickBelief(nm) {
    var steps = nm.querySelectorAll('[data-step]'), n = steps.length;
    if (nm.hasAttribute('data-fade')) {
      if (rm()) { [].forEach.call(steps, function (s) { s.style.opacity = '1'; }); return; }
      var r0 = nm.getBoundingClientRect(), p0 = cl(-(r0.top - hh) / Math.max(1, r0.height - (innerHeight - hh)) / 0.8);
      var on = Math.round(p0 * n);
      [].forEach.call(steps, function (s, i) { s.style.opacity = i < on ? '1' : '0.12'; });
      return;
    }
    if (rm()) { nm.style.height = ''; [].forEach.call(steps, function (s) { s.style.opacity = '1'; s.style.transform = 'none'; s.style.filter = ''; }); return; }
    var sp = nm.firstElementChild, stk = nm.querySelector('[data-belief-stick]');
    if (!sp || !stk) return;
    nm.style.height = (sp.offsetHeight + stk.offsetHeight + innerHeight * 1.3) + 'px';
    var r = nm.getBoundingClientRect(), run = Math.max(1, r.height - sp.offsetHeight - stk.offsetHeight);
    var p = cl((-(r.top + sp.offsetHeight) + stk.offsetHeight * 0.35) / run);
    if (!nm._tw) { nm._tw = true; [].forEach.call(steps, function (s) { s.style.transition = 'opacity 900ms cubic-bezier(0.22, 1, 0.36, 1), transform 900ms cubic-bezier(0.22, 1, 0.36, 1), filter 900ms cubic-bezier(0.22, 1, 0.36, 1)'; }); }
    [].forEach.call(steps, function (s, i) {
      var st = i * (0.62 / Math.max(1, n - 1)), k = cl((p - st) / 0.38), e = k * k * (3 - 2 * k);
      s.style.opacity = (0.12 + 0.88 * e).toFixed(3);
      s.style.transform = 'translate3d(0,' + ((1 - e) * 18).toFixed(1) + 'px,0)';
      s.style.filter = 'blur(' + ((1 - e) * 6).toFixed(2) + 'px)';
    });
  }

  function tickChapters(sec) {
    var arts = sec.querySelectorAll('[data-ch]'); if (!arts.length) return;
    var vh = innerHeight, best = 0, bd = Infinity;
    [].forEach.call(arts, function (c, i) { var r = c.getBoundingClientRect(), d = Math.abs(r.top + r.height / 2 - vh * 0.5); if (d < bd) { bd = d; best = i; } });
    if (sec._ch === best) return; sec._ch = best;
    [].forEach.call(arts, function (c, i) { c.classList.toggle('is-active', i === best); });
    $$('.story-ch__stick > *', sec).forEach(function (im, i) { im.classList.toggle('is-active', i === best); });
  }

  function tickParallax() {
    if (rm()) return;
    var vh = innerHeight;
    parallax.forEach(function (el) {
      var img = el.firstElementChild; if (!img) return;
      var r = el.getBoundingClientRect(); if (r.bottom < -300 || r.top > vh + 300) return;
      var y = ((r.top + r.height / 2 - vh / 2) * +el.getAttribute('data-brand-px')).toFixed(1);
      img.style.transform = 'translate3d(0,' + y + 'px,0) scale(1.16)';
    });
  }

  var raf = 0;
  function tick() {
    raf = 0;
    heroes.forEach(tickHero); beliefs.forEach(tickBelief); chapters.forEach(tickChapters); tickParallax();
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(tick); }
  var bound = false;
  function bind() {
    if (bound) return; bound = true;
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', function () { measure(); schedule(); });
    if (mq.addEventListener) mq.addEventListener('change', schedule);
  }

  /* ---------- reveal on scroll ---------- */
  var io = null;
  function initReveal(root) {
    if (rm() || !('IntersectionObserver' in window)) return;
    if (!io) io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.style.opacity = '1'; e.target.style.transform = 'none'; io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    var ease = 'cubic-bezier(0.22, 1, 0.36, 1)';
    $$('[data-brand-reveal], [data-brand-reveal-kids] > *', root).forEach(function (el) {
      if (el._rv) return; el._rv = true;
      if (el.getBoundingClientRect().top < innerHeight) return;
      var sibs = el.parentElement ? [].slice.call(el.parentElement.children) : [el], sib = Math.max(0, sibs.indexOf(el));
      el.style.opacity = '0'; el.style.transform = 'translateY(40px)';
      el.style.transition = 'opacity 1100ms ' + ease + ' ' + (sib * 90) + 'ms, transform 1100ms ' + ease + ' ' + (sib * 90) + 'ms';
      io.observe(el);
    });
  }

  /* ---------- press filters ---------- */
  function initPress(root) {
    $$('[data-press]', root).forEach(function (sec) {
      if (sec._init) return; sec._init = true;
      var btns = $$('[data-press-cat]', sec), cards = $$('[data-press-card]', sec);
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var c = b.getAttribute('data-press-cat');
          btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          cards.forEach(function (card) { card.hidden = !(c === '*' || (card.getAttribute('data-cat') || '').toLowerCase() === c.toLowerCase()); });
        });
      });
    });
  }

  /* ---------- contact forms (collaborations, wholesale) ---------- */
  var EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  function initForms(root) {
    $$('form[data-brand-form]', root).forEach(function (form) {
      if (form._init) return; form._init = true;
      var mode = form.getAttribute('data-brand-form'), box = form.querySelector('[data-form-error]');
      form.addEventListener('submit', function (e) {
        var bad = null;
        $$('input, select, textarea', form).forEach(function (el) {
          if (el.type === 'hidden' || el.type === 'submit') return;
          var v = (el.value || '').trim(), msg = null;
          var label = el.getAttribute('aria-label') || el.placeholder || (el.closest('label') && el.closest('label').querySelector('span') ? el.closest('label').querySelector('span').textContent : '') || 'This field';
          if (el.required && !v) msg = label.replace(/\s*\*$/, '') + ' is required.';
          else if (el.type === 'email' && (v || mode === 'collab') && !EMAIL.test(v)) msg = 'Enter an email like name@example.com' + (mode === 'collab' ? '' : '.');
          el.setAttribute('aria-invalid', msg ? 'true' : 'false');
          var own = el.parentElement && el.parentElement.querySelector('[data-field-error]');
          if (own) own.hidden = !msg;
          if (msg && !bad) bad = { el: el, msg: msg };
        });
        if (bad) {
          e.preventDefault(); bad.el.focus();
          if (box) { box.textContent = bad.msg; box.hidden = false; }
          return;
        }
        if (box) box.hidden = true;
        try {
          var nm = form.querySelector('[name="contact[name]"]'), em = form.querySelector('[name="contact[email]"]');
          sessionStorage.setItem('yu-brand-form', JSON.stringify({ name: nm ? nm.value.trim() : '', email: em ? em.value.trim() : '' }));
        } catch (err) { /* storage unavailable */ }
      });
      $$('input, textarea', form).forEach(function (el) { el.addEventListener('input', function () { if (el.getAttribute('aria-invalid') === 'true') { el.setAttribute('aria-invalid', 'false'); var own = el.parentElement && el.parentElement.querySelector('[data-field-error]'); if (own) own.hidden = true; } }); });
    });
    /* success state: personalise with what was typed before the post */
    $$('[data-form-done]', root).forEach(function (done) {
      if (done._init) return; done._init = true;
      var data = null;
      try { data = JSON.parse(sessionStorage.getItem('yu-brand-form') || 'null'); } catch (err) { data = null; }
      if (!data) return;
      var first = (data.name || '').split(' ')[0];
      $$('[data-done-name]', done).forEach(function (n) { if (first) n.textContent = first; });
      $$('[data-done-email]', done).forEach(function (n) { if (data.email) n.textContent = data.email; });
    });
  }

  /* ---------- rewards points calculator ---------- */
  function initCalc(root) {
    $$('[data-rw-calc]', root).forEach(function (sec) {
      if (sec._init) return; sec._init = true;
      var ppd = parseFloat(sec.getAttribute('data-ppd')) || 5, per = parseInt(sec.getAttribute('data-per'), 10) || 100,
        valCents = parseInt(sec.getAttribute('data-value'), 10) || 500, cur = sec.getAttribute('data-currency') || 'USD';
      var items = $$('[data-rw-item]', sec), num = sec.querySelector('[data-rw-num]'), sum = sec.querySelector('[data-rw-summary]'),
        fill = sec.querySelector('[data-rw-fill]'), tiers = $$('[data-rw-tier]', sec);
      var t = {
        empty: sec.getAttribute('data-t-empty') || '', more: sec.getAttribute('data-t-more') || '',
        worth: sec.getAttribute('data-t-worth') || '', next: sec.getAttribute('data-t-next') || ''
      };
      var fmt;
      try { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: cur, minimumFractionDigits: 0, maximumFractionDigits: 2 }); } catch (err) { fmt = null; }
      var money = function (cents) { var v = cents / 100; return fmt ? fmt.format(v) : '$' + v; };
      var ptsFor = function (cents) { return Math.floor((cents / 100) * ppd); };
      items.forEach(function (b) { var pe = b.querySelector('[data-rw-pts]'); if (pe) pe.textContent = ptsFor(+b.getAttribute('data-price')).toLocaleString('en-US') + ' pts'; });
      var shown = 0, tw = 0;
      var target = function () {
        var spend = 0;
        items.forEach(function (b) { if (b.getAttribute('aria-pressed') === 'true') spend += +b.getAttribute('data-price'); });
        return Math.floor((spend / 100) * ppd);
      };
      var paint = function () { if (num) num.textContent = shown.toLocaleString('en-US'); };
      var render = function () {
        var pts = target(), worth = Math.floor(pts / per) * valCents, nextTier = null, max = per * tiers.length;
        tiers.forEach(function (el) { var p = +el.getAttribute('data-rw-tier'); var got = pts >= p; el.classList.toggle('is-on', got); if (!got && nextTier === null) nextTier = el; });
        var s;
        if (pts === 0) s = t.empty;
        else if (worth === 0) s = t.more.replace('[points]', (per - pts).toLocaleString('en-US')).replace('[value]', money(valCents));
        else s = t.worth.replace('[value]', money(worth)) + (nextTier ? t.next.replace('[points]', (+nextTier.getAttribute('data-rw-tier') - pts).toLocaleString('en-US')).replace('[value]', nextTier.textContent.trim()) : '.');
        if (sum) sum.textContent = s;
        if (fill) fill.style.width = Math.min(100, max ? (pts / max) * 100 : 0) + '%';
        tween();
      };
      var tween = function () {
        var to = target(); if (to === shown || tw) return;
        if (rm()) { shown = to; paint(); return; }
        var from = shown, t0 = performance.now(), dur = 650;
        var step = function (now) {
          var k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3), goal = target();
          shown = Math.round(from + (goal - from) * e); paint();
          if (k < 1) tw = requestAnimationFrame(step); else { tw = 0; if (shown !== target()) tween(); }
        };
        tw = requestAnimationFrame(step);
      };
      items.forEach(function (b) {
        b.addEventListener('click', function () {
          var on = b.getAttribute('aria-pressed') !== 'true';
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          var m = b.querySelector('[data-rw-mark]'); if (m) m.textContent = on ? '✓' : '+';
          render();
        });
      });
      render();
    });
  }

  /* ---------- init ---------- */
  function init(root) {
    measure();
    $$('[data-xhero]', root).forEach(function (el) { if (heroes.indexOf(el) < 0) heroes.push(el); });
    $$('[data-belief]', root).forEach(function (el) {
      var txt = el.querySelector('[data-belief-text]'); if (txt) splitWords(txt);
      if (el.hasAttribute('data-fade') && !rm()) $$('[data-step]', el).forEach(function (s) { s.style.opacity = '0.12'; });
      if (beliefs.indexOf(el) < 0) beliefs.push(el);
    });
    $$('[data-chapters]', root).forEach(function (el) { if (chapters.indexOf(el) < 0) chapters.push(el); });
    $$('[data-brand-px]', root).forEach(function (el) { if (parallax.indexOf(el) < 0) parallax.push(el); });
    /* drop elements removed by the theme editor */
    var alive = function (el) { return D.documentElement.contains(el); };
    heroes = heroes.filter(alive); beliefs = beliefs.filter(alive); chapters = chapters.filter(alive); parallax = parallax.filter(alive);
    initReveal(root); initPress(root); initForms(root); initCalc(root);
    bind(); tick();
    setTimeout(function () { measure(); tick(); }, 600);
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { init(D); });
  else init(D);
  D.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
